export default (pollId: string): string => {
    return `poll/${pollId}/__`;
};
